import { useTranslation } from 'react-i18next';

// Get locale from cookie
const getLocaleFromCookie = () => {
  const match = document.cookie.match(/(^|;)\s*locale=([^;]*)/);
  return match ? decodeURIComponent(match[2]) : "en";
};

const PageTitle = ({ title, subtitle }) => {
  const locale = getLocaleFromCookie();
  const { t } = useTranslation();

  const formattedDate =
    subtitle &&
    new Date(subtitle).toLocaleDateString(locale, {
      day: "numeric",
      month: "long",
      year: "numeric",
    });

  return (
    <div className="container mt-5 mt-xl-10">
      <div className="row mb-5 g-3 g-xl-5 align-items-end">
        <div className="col-lg-12">
          <h1 style={{ lineHeight: '80%' }}>
            <span className="display-2 text-black" style={{ fontWeight: 'bold', lineHeight: '50%' }}>{title}</ span>
            {formattedDate && (
              <>
                <br />
                <span className="eyebrow text-black" style={{ lineHeight: '50%' }}>
                  {t("privacyPolicy.lastUpdatedOn")} {formattedDate}
                </span>
              </>
            )}
          </h1>
        </div>
      </div>
    </div>
  );
};

export default PageTitle;

